<template>
    <a-tag :color="get_task_type_color(taskType)">
        {{taskType}}
    </a-tag>{{text}}
</template>

<script>
    import {get_task_type_color} from "../utils/biomed.api";

    export default {
        name: "TaskTypeTag",
        props: ['taskType', 'text'],
        methods: {
            get_task_type_color
        }
    }
</script>

<style scoped>

</style>